import React, { useEffect } from 'react';
import styles from './EleventhScreen.module.css';
import ScrollReveal from 'scrollreveal';
import FAQItem from '../ReceptionistComponents/questions/Questions';
import Button from '../ReceptionistComponents/button/Button';

const EleventhScreenRec = () => {
  const faqData = [
    {
      question: 'האם ה-AI לא עומד להחליף את המקצוע הזה בקרוב?',
      answer: 'להפך. ה-AI הוא כלי עבודה מדהים, אבל הוא צריך מישהי שתנהל אותו. בהכשרה נלמד איך לרתום את הבינה המלאכותית כדי לעבוד מהר יותר, אבל המגע האנושי, האינטואיציה העסקית והתקשורת שלך הם דברים ששום מכונה לא תוכל להחליף. בעלי עסקים צריכים מנהלת, לא רק רובוט.'
    },
    {
      question: 'אני חוששת מהמעבר לעצמאות ומכל נושא הכסף והגבייה...',
      answer: 'זה החשש הכי נפוץ, ובדיוק בשביל זה הבאנו את המומחים שלנו. את תלמדי בדיוק איך לתמחר, איך להתנהל מול הבנק ואיך לדרוש את מה שמגיע לך בביטחון מלא. את לא יוצאת לדרך לבד, את יוצאת עם ארגז כלים פיננסי סגור.'
    },
    {
      question: 'האם ההכשרה מתאימה גם למי שאין לה ניסיון קודם בניהול?',
      answer: 'לגמרי. אנחנו מתחילים מהיסודות. אם את אישה ש"מתקתקת" עניינים, אוהבת סדר ויודעת לפתור בעיות – יש לך את כל מה שצריך. אנחנו רק נותנים לך את המסגרת המקצועית כדי להפוך את זה לעסק.'
    },
    {
      question: 'איך אני אמצא לקוחות אחרי ההכשרה?',
      answer: 'בתוך ההכשרה אנחנו מקדישים זמן לזווית השיווקית. נלמד איך למתג את עצמך ואיך להגיע לאותם בעלי עסקים שמשוועים למישהי כמוך שתעשה להם סדר בבלאגן.'
    },
    {
      question: 'מה קורה אם אני לא יכולה להגיע לאחד המפגשים?',
      answer: 'ההכשרה היא אונליין וחשוב לנו הקשר האישי, אבל אנחנו כאן כדי לעזור. דברי איתנו וניתן לך את המענה המשלים כדי שלא תפספסי שום חומר מקצועי.'
    }
  ];

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.subtitle}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 100,
    });
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>
          כל מה שרצית לדעת נמצא כאן
        </h2>
        
        <p className={styles.subtitle}>
          ריכזנו את השאלות שכנראה עלו לך לראש במהלך הדף, לחץ על כל שאלה והתשובה תיפתח.
        </p>

        <div className={styles.questionsContainer}>
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
        
        <Button text="קרן יש לי עוד שאלה" />
      </div>
    </section>
  );
};

export default EleventhScreenRec;
